export const pushGtmEvent = (event: string, params?: any) =>
  window?.dataLayer?.push({ event, ...params })
